export default function Footer() {
  return (
    <footer className="border-t border-[#e5e2da] mt-24" data-testid="marketing-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-12 grid md:grid-cols-4 gap-8 text-sm">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2 mb-3">
            <div className="w-7 h-7 rounded-full flex items-center justify-center text-[#f9f8f6] font-serif-display text-lg" style={{ background: "#163325" }}>C</div>
            <span className="font-serif-display text-xl">Coachly</span>
          </div>
          <p className="text-[#5c5c5c] max-w-md">
            AI sales assistant for coaches. Turn your existing website traffic into booked calls, without hiring another salesperson.
          </p>
        </div>
        <div>
          <div className="font-medium mb-3">Product</div>
          <ul className="space-y-2 text-[#5c5c5c]">
            <li><a href="#how" className="hover:text-[#163325]">How it works</a></li>
            <li><a href="#pricing" className="hover:text-[#163325]">Pricing</a></li>
            <li><a href="#faq" className="hover:text-[#163325]">FAQ</a></li>
          </ul>
        </div>
        <div>
          <div className="font-medium mb-3">Company</div>
          <ul className="space-y-2 text-[#5c5c5c]">
            <li>hello@coachly.ai</li>
            <li>© {new Date().getFullYear()} Coachly Labs</li>
          </ul>
        </div>
      </div>
    </footer>
  );
}
